import Icon from '../../../components/AppIcon';

interface IndustrySelectorProps {
  industries: { id: string; name: string; icon: string }[];
  activeIndustry: string;
  onSelectIndustry: (industryId: string) => void;
}

const IndustrySelector = ({ industries, activeIndustry, onSelectIndustry }: IndustrySelectorProps) => {
  return (
    <section className="sticky top-16 z-40 bg-background/95 backdrop-blur-brand border-b border-border py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center space-x-2 overflow-x-auto scrollbar-hide">
          {industries.map((industry) => (
            <button
              key={industry.id}
              onClick={() => onSelectIndustry(industry.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg whitespace-nowrap transition-all duration-300 ${
                activeIndustry === industry.id
                  ? 'bg-primary text-primary-foreground shadow-brand'
                  : 'bg-muted text-foreground hover:bg-muted/80'
              }`}
            >
              <Icon name={industry.icon} size={16} />
              <span className="text-sm">{industry.name}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustrySelector;